const CHUNK_ERROR_PATTERN =
  /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|ChunkLoadError/i

const isChunkLoadError = err =>
  CHUNK_ERROR_PATTERN.test(err?.message || "") ||
  err?.name === "ChunkLoadError"

export const loadPageComponent = async page => {
  const pages = import.meta.glob([
    "../pages/**/*.{js,jsx}",
    "!../pages/**/(__tests__|components|assets|utils|hooks|widgets|test-support|support|store|queries|default-content|templates)/**/*.{js,jsx}",
    "!../pages/**/(constants|typedefs).{js,jsx}"
  ])

  const pageFn =
    pages[`../pages/${page}.js`] ||
    pages[`../pages/${page}.jsx`] ||
    pages[`../pages/${page}/index.js`] ||
    pages[`../pages/${page}/index.jsx`] ||
    pages[`../pages/${page}.page.js`] ||
    pages[`../pages/${page}.page.jsx`] ||
    pages[`../pages/${page}/index.page.js`] ||
    pages[`../pages/${page}/index.page.jsx`]

  if (typeof pageFn !== "function") {
    throw new Error(`Page component not found: ${page}`)
  }

  try {
    return await pageFn()
  } catch (err) {
    if (!isChunkLoadError(err)) throw err

    // Stale chunk after a deploy: the hashed JS file the user's session is
    // trying to import no longer exists on the CDN. Reload once to pick up
    // the current manifest. SessionStorage guards against an infinite loop
    // if the chunk is genuinely broken.
    const reloadKey = `chunk-reload:${page}`
    if (typeof sessionStorage !== "undefined" && !sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, "1")
      window.location.reload()
      return new Promise(() => {})
    }
    throw err
  }
}
